import jsPDF from 'jspdf';
import 'jspdf-autotable';

export function triggerBlobDownload(data, filename, mimeType = 'application/octet-stream') {
  const blob = data instanceof Blob ? data : new Blob([data], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export function buildPermissionExportFilename({ module = '', extension = 'csv' } = {}) {
  const stamp = new Date().toISOString().slice(0, 10);
  const moduleSuffix = module ? `_${String(module).replace(/[^\w-]+/g, '_')}` : '';
  return `permissions${moduleSuffix}_${stamp}.${extension}`;
}

export function exportPermissionsPdf(permissions, { title = 'Permissions Export', filtersSummary = '', module = '' } = {}) {
  const doc = new jsPDF('l', 'mm', 'a4');
  doc.setFontSize(16);
  doc.setTextColor(49, 46, 129);
  doc.text(title, 14, 15);
  doc.setFontSize(9);
  doc.setTextColor(107, 114, 128);
  doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 21);
  doc.text(`Total permissions: ${permissions.length}`, 14, 26);
  if (filtersSummary) {
    doc.text(filtersSummary, 14, 31);
  }

  const tableData = permissions.map((p) => [
    p.name || '',
    p.code || '',
    p.module || '',
    p.resource || '',
    p.action || '',
    p.category || '',
    p.isActive !== false ? 'Active' : 'Inactive',
    p.description || '',
  ]);

  doc.autoTable({
    startY: filtersSummary ? 36 : 32,
    head: [['Name', 'Code', 'Module', 'Resource', 'Action', 'Category', 'Status', 'Description']],
    body: tableData,
    styles: { fontSize: 7, cellPadding: 1.5 },
    headStyles: { fillColor: [79, 70, 229], textColor: 255 },
    alternateRowStyles: { fillColor: [249, 250, 251] },
    margin: { left: 14, right: 14 },
  });

  doc.save(buildPermissionExportFilename({ module, extension: 'pdf' }));
}
